import ActionTypes from "../actionTypes/actionTypes";

export default (state = false, action) => {
    switch (action.type) {
        case ActionTypes.IS_USER_AUTHORIZED_SUCCESS : {
            return action.isAuthorized;
        }
        default:
            return state        
    }
}